export default __webpack_public_path__ + "static/media/WRB_S_XLG.470c37bb.png";